import React from 'react'
import { Routes, Route } from 'react-router-dom'
import SettingsLayout from './settings/SettingsLayout'

// Import all settings pages
import SettingsIndex from './settings/index'
import ProfileSettings from './settings/profile/index'
import AccountsSettings from './settings/accounts/index'
import UsersSettings from './settings/users/index'
import RolesSettings from './settings/roles/index'
import TeamsSettings from './settings/teams/index'
import ModulesSettings from './settings/modules/index'
import PipelineSettings from './settings/pipeline/index'
import FunnelManagementSettings from './settings/funnel-management/index'
import FormFieldsSettings from './settings/form-fields/index'
import RoundRobinGroupsSettings from './settings/round-robin-groups/index'
import RoundRobinLogsSettings from './settings/round-robin-logs/index'
import FacebookPixelIntegrationSettings from './settings/facebook-pixel-integration/index'
import WebsiteIntegrationSettings from './settings/website-integration/index'
import PhoneIntegrationSettings from './settings/phone-integration/index'
import OutboundCallingSettings from './settings/outbound-calling/index'
import AiSensySettings from './settings/aisensy/index'
import WatiSettings from './settings/wati/index'
import BrevoSettings from './settings/brevo/index'
import FacebookPagesSettings from './settings/facebook-pages/index'
import DesktopNotificationsSettings from './settings/desktop-notifications/index'
import TransitionRulesSettings from './settings/transition-rules/index'
import LoginHistorySettings from './settings/login-history/index'
import SessionManagementSettings from './settings/session-management/index'
import DripCampaignsSettings from './settings/drip-campaigns/index'
import EmailTemplatesSettings from './settings/drip-campaigns/templates/index'
import EmailBrandingSettings from './settings/drip-campaigns/branding/index'
import ClientInfoSettings from './settings/client-info/index'
import ImportSettings from './settings/import/index'
import ImportKnowlaritySettings from './settings/import-knowlarity/index'
import { Navigate } from 'react-router-dom'
import RRCategoriesSettings from './settings/rr-assignment/categories/index'
import RRMappingSettings from './settings/rr-assignment/mapping/index'
import RRCapsSettings from './settings/rr-assignment/caps/index'
import RRHoursSettings from './settings/rr-assignment/hours/index'
import AttendancePage from './Attendance'
import QueuePage from './rr-queue/index'
import WorkloadPage from './rr-workload/index'
import MonitorPage from './rr-monitor/index'
import HistoryPage from './rr-history/index'

const Settings: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<SettingsLayout />}>
        <Route index element={<SettingsIndex />} />
        <Route path="profile" element={<ProfileSettings />} />
        <Route path="accounts" element={<AccountsSettings />} />
        <Route path="users" element={<UsersSettings />} />
        <Route path="roles" element={<RolesSettings />} />
        <Route path="teams" element={<TeamsSettings />} />
        <Route path="modules" element={<ModulesSettings />} />
        <Route path="pipeline" element={<PipelineSettings />} />
        <Route path="funnel-management" element={<FunnelManagementSettings />} />
        <Route path="form-fields" element={<FormFieldsSettings />} />
        <Route path="round-robin-groups" element={<RoundRobinGroupsSettings />} />
        <Route path="round-robin-logs" element={<RoundRobinLogsSettings />} />
        <Route path="facebook-pixel-integration" element={<FacebookPixelIntegrationSettings />} />
        <Route path="website-integration" element={<WebsiteIntegrationSettings />} />
        <Route path="phone-integration" element={<PhoneIntegrationSettings />} />
        <Route path="outbound-calling" element={<OutboundCallingSettings />} />
        <Route path="aisensy" element={<AiSensySettings />} />
        <Route path="wati" element={<WatiSettings />} />
        <Route path="brevo" element={<BrevoSettings />} />
        <Route path="facebook-pages" element={<FacebookPagesSettings />} />
        <Route path="desktop-notifications" element={<DesktopNotificationsSettings />} />
        <Route path="transition-rules" element={<TransitionRulesSettings />} />
        <Route path="login-history" element={<LoginHistorySettings />} />
        <Route path="session-management" element={<SessionManagementSettings />} />
        <Route path="drip-campaigns" element={<DripCampaignsSettings />} />
        <Route path="drip-campaigns/templates" element={<EmailTemplatesSettings />} />
        <Route path="drip-campaigns/branding" element={<EmailBrandingSettings />} />
        <Route path="client-info" element={<ClientInfoSettings />} />
        <Route path="import" element={<ImportSettings />} />
        <Route path="import-knowlarity" element={<ImportKnowlaritySettings />} />
        {/* Round Robin Assignment — config */}
        <Route path="rr-assignment" element={<Navigate to="/settings/rr-assignment/categories" replace />} />
        <Route path="rr-assignment/categories" element={<RRCategoriesSettings />} />
        <Route path="rr-assignment/mapping" element={<RRMappingSettings />} />
        <Route path="rr-assignment/caps" element={<RRCapsSettings />} />
        <Route path="rr-assignment/hours" element={<RRHoursSettings />} />
        {/* Round Robin Assignment — dashboard */}
        <Route path="rr-attendance" element={<AttendancePage />} />
        <Route path="rr-queue" element={<QueuePage />} />
        <Route path="rr-workload" element={<WorkloadPage />} />
        <Route path="rr-monitor" element={<MonitorPage />} />
        <Route path="rr-history" element={<HistoryPage />} />
      </Route>
    </Routes>
  )
}

export default Settings